export const GTMTrigger = (event: string) => {
  if (!event) {
    return;
  }

  // Move this out of the event handler to avoid blocking the main thread and onto the next tick
  setTimeout(() => {
    window?.dataLayer?.push?.({ event });
  }, 0);
};

export const snowplowEvent = (
  { schema, version = '1-0-0', ...payload }: { [key: string]: any; schema: string; version?: string },
) => {
  // Move this out of the event handler to avoid blocking the main thread and onto the next tick
  setTimeout(() => {
    window?.snowplow?.('trackSelfDescribingEvent', {
      event: {
        data: {},
        schema: `iglu:uk.co.motorway/${schema}/jsonschema/${version}`,
        ...payload,
      },
    });
  }, 0);
};

export const PAGES = Object.freeze({
  ACCOUNT: 'Account',
  CONFIRM_TIMEFRAME: 'Confirm timeframe',
  CONSENT: 'Consent',
  ENQUIRY: 'Enquiry',
  ESTIMATED_SALE_PRICES_MODAL: 'Modal estimated sale prices',
  FINANCE_SETTLEMENT_LETTER: 'Finance settlement letter',
  FOOTER: 'Footer',
  FORGOT_PASSWORD: 'Forgot password',
  HEADER: 'Header',
  HERO: 'Hero',
  HOME: 'homepage',
  LANDINGPAGE: 'Landing Page',
  MARKETPLACE: 'Marketplace valuation',
  MARKETPLACE_PROGRESS: 'Marketplace valuation (in progress)',
  MENTIONME: 'Mention Me',
  NONELIGIBLE: 'Non eligible',
  PREMIUM_VEHICLE_INFORMATION: 'Premium vehicle information',
  PROFILE: 'Profile page',
  PROOF_OF_ADDRESS: 'Proof of address',
  SALE_CONFIRMATION: 'Sale confirmation page',
  SERVICE_HISTORY: 'Service History',
  SIGN_IN: 'Sign in',
  SIGN_IN_VRM: 'Sign in (existing VRM)',
  SIGN_UP: 'Sign up',
  TIMELINE: 'Timeline',
  ULEZ: 'ULEZ Landing Page',
  ULEZ_RESULTS: 'ULEZ Results Page',
  UPDATED_VALUATION: 'Updated valuation',
  VALUATION_EXPIRED: 'Valuation expired',
  VALUATION_UNAVAILABLE: 'Valuation unavailable',
  VEHICLE_PAYMENT: 'Vehicle payment',
});

export const GA_EVENT_TYPES = Object.freeze({
  BUTTON: 'button',
  EMAIL: 'email',
  PAGE_LOADER: 'page loader - custom event',
  PHONE: 'telephone',
});

export const GTM_TRIGGERS = Object.freeze({
  CONFIRM_SALE_BUTTON_ACCEPTED_VALUE: () => GTMTrigger('confirm_sale'),
  ENQUIRY_CREATED: () => GTMTrigger('enquiry_created'),
  OFFER_SELECTED: () => GTMTrigger('offer_selected'),
  VEHICLE_LOOKUP_COMPLETE: () => GTMTrigger('vehicle_lookup_complete'),
});

interface GATagsProxy {
  [key: string]: (...args: any[]) => void;
}

export const GA_TAGS: GATagsProxy = new Proxy({}, {
  get: () => () => {},
});
